<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="确认组货"
      :innerHeight="160"
      width="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-form :model="form" size="small" :inline="true" :rules="rules" ref="ruleForm" label-width="110px">
        <el-form-item label="实际到货时间" prop="a">
          <el-input v-model.trim="form.a" />
        </el-form-item>
        <el-form-item label="配货人员" prop="b">
          <el-input v-model.trim="form.b" />
        </el-form-item>
        <el-form-item label="备注" prop="c">
          <el-input v-model.trim="form.c" />
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    return {
      dialogVisible: false,
      // 业务
      form: {},
      rules: {
        a: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        b: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    // 业务
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.updateVal();
        }
      })
    },
    // 业务

  }
}
</script>

<style>

</style>